import { CheckMarkV2Icon } from '@/assets/CheckMarkV2Icon';
import React, { ReactNode } from 'react';

export interface GetStartedCardProps {
  title?: string;
  subTitle?: string;
  children?: ReactNode[];
  footerImg?: ReactNode;
}

export const GetStartedCard = ({
  title,
  subTitle,
  footerImg,
  children,
}: GetStartedCardProps) => {
  return (
    <section className="container mx-auto px-6 md:px-16">
      <div className="px-[25px] py-5 flex flex-col gap-y-[25px] bg-white shadow-container rounded-2xl">
        <p className="text-center font-bold text-lg">{title}</p>
        <div className="block">
          <p className="mb-5">{subTitle}</p>
          <ul className="flex flex-col gap-y-4">
            {children &&
              children.map((bulletItem, i) => (
                <li className="flex items-start flex-row gap-x-4" key={i}>
                  <div>
                    <CheckMarkV2Icon />
                  </div>
                  <div>{bulletItem}</div>
                </li>
              ))}
          </ul>
          {footerImg}
        </div>
      </div>
    </section>
  );
};
